import AddEditSystemMessage from './AddEditSystemMessage';

export default AddEditSystemMessage;
